import AirDatepicker from 'air-datepicker';
import localeDe from 'air-datepicker/locale/de';
import 'air-datepicker/air-datepicker.css';
import ca from "air-datepicker/locale/ca";
import da from "air-datepicker/locale/da";

function adFormatDate(date) {
    return date.getFullYear() +
        '-' +
        String(date.getMonth() + 1).padStart(2, '0') +
        '-' +
        String(date.getDate()).padStart(2, '0');
}

function initSubscriptionDatepicker() {
    const section = document.querySelector('section[x-data]#subscription-detail-section');
    if (!section) return;


    const alpineData = Alpine.$data(section);
    const el = document.querySelector('#abo-datepicker');
    const country = el.dataset.country;

    if (!el) return;

    let deliveryDates = {};
    const prev = el.previousElementSibling;
    if (prev && prev.textContent.trim()) {
        try {
            deliveryDates = JSON.parse(prev.textContent);
        } catch (e) {
            return;
        }
    }

    const firstKey = Object.keys(deliveryDates)[0];
    const minDate = firstKey ? new Date(firstKey) : null;

    const calendar = new AirDatepicker('#abo-datepicker', {
        inline: true,
        locale: localeDe,
        minDate,
        onBeforeSelect({date}) {
            if (!date) return;
            const formatted = adFormatDate(date);
            let curDate = country === 'AT' ? getWeekDates(date).find(d => deliveryDates[d]) : formatted;

            const isActive = !!deliveryDates[curDate];

            if (isActive) {
                if (alpineData.pauseDates.includes(curDate)) {
                    alpineData.pauseDates = [...alpineData.pauseDates].filter(d => d !== curDate);
                } else {
                    if (!alpineData.pauseDates.includes(curDate)) {
                        alpineData.pauseDates.push(curDate);
                    }
                }

                calendar.update();
            }
            return false;
        },

        onRenderCell({date, cellType}) {
            if (cellType !== 'day') return;

            const formatted = adFormatDate(date);
            let curDate = country === 'AT' ? getWeekDates(date).find(d => deliveryDates[d]) : formatted;
            let isActive = !!curDate && !!deliveryDates[curDate];
            if (cellType === 'day' && [0, 6].includes(date.getDay())) {
                isActive = false;
            }
            let classes = [];
            let html = null;

            if (isActive) {
                const isPaused = alpineData.pauseDates.includes(curDate);
                classes.push('-enabled-', isPaused ? '-paused-' : '-active-');
                html = `<span>${date.getDate()}<span><i class="fas ${isPaused ? 'fa-pause' : 'fa-check'}"></i></span></span>`;
                if(country === 'AT') {
                    classes.push('active-day day-' + date.getDay());
                }
            } else {
                classes.push('-disabled-');
            }


            return {html, classes: classes.join(' ').trim()};
        },
    });


    Alpine.watch(() => alpineData.editDatesModal, (isOpen) => {
        if (isOpen) {
            alpineData.pauseDates = Object.entries(deliveryDates)
                .filter(([, v]) => v?.is_paused)
                .map(([d]) => d);

            calendar.update();
        } else {
            alpineData.pauseDates = [];
        }
    });
}


function initCart() {
    const section = document.querySelector('.AktivdogCartTable');
    if (!section) return;


    section.querySelectorAll('.order-type-modal-wrap').forEach(el => {
        const alpineData = Alpine.$data(el);
        Alpine.watch(() => alpineData.showOrderTypeModal, (isOpen) => {
            document.body.classList.toggle('order-type-modal-open', isOpen);
        });
    });


}

function initAjaxCartNumber(){
    const els = document.querySelectorAll(".fusion-widget-cart-number");
    if (!els.length) return;

    const ajaxUrl = window.ajaxurl ? window.ajaxurl : "/wp-admin/admin-ajax.php";

    fetch(ajaxUrl + "?action=get_cart_count", { credentials: "same-origin" })
        .then(r => r.json())
        .then(res => {
            if (!res || !res.success) return;

            const count = parseInt(res.data.count || 0, 10);

            els.forEach(el => {
                el.textContent = count;
                el.setAttribute("data-cart-count", count);
                el.setAttribute("data-digits", String(count).length);
                el.classList.setAttribue('data-loaded', true);
                console.log(el);
            });
        })
        .catch(() => {});
}

function initDeliveryTimeInfo() {
    const section = document.querySelectorAll('.delivery-time-info');
    if (!section.length) return;

    const domainArray = window.location.hostname.split(".");
    const domainEnding = (domainArray[domainArray.length - 1] || "").toUpperCase();


    section.forEach((el, i) => {
        if(el.dataset.country !== domainEnding){
            el.remove();
        }
    });

}

function getWeekDates(date, dateObjects = false) {
    const selectedDate = new Date(date);
    const day = selectedDate.getDay();
    const monday = new Date(selectedDate);
    monday.setDate(monday.getDate() - day + 1);

    const dates = [];
    for (let i = 0; i < 5; i++) {
        const d = new Date(monday);
        d.setDate(monday.getDate() + i);
        if(dateObjects) {
            dates.push(d);
        }else {
            dates.push(d.getFullYear() + '-' +
                String(d.getMonth() + 1).padStart(2, '0') + '-' +
                String(d.getDate()).padStart(2, '0'));
        }
    }

    return dates;
}


function getWeekNumber(date) {
    // Datum kopieren, um Original nicht zu verändern
    const d = new Date(date.getTime());
    // Setze das Datum auf den nächsten Donnerstag (Montag + 3 Tage)
    // getDay(): 0=Sonntag, 1=Montag, ..., 6=Samstag
    d.setDate(d.getDate() + 4 - (d.getDay() || 7));
    // Hole den ersten Tag des Jahres (Januar 1)
    const yearStart = new Date(d.getFullYear(), 0, 1);
    // Berechne die Differenz in Tagen
    const diff = d - yearStart;
    // Teile durch Millisekunden pro Tag und runde
    // Fügen 1 hinzu, da es die KW 1 ist (nicht 0)
    return Math.ceil(((diff / 86400000) + 1) / 7);
}


function initFirstDeliveryDatepicker() {
    document.querySelectorAll('input.first_delivery_date-input').forEach(input => {

        let minDate = new Date(input.dataset.minDate);
        let startDate = new Date(input.dataset.startDate);
        let country = input.dataset.country;

        const calendar = new AirDatepicker('#' + input.id, {
            minDate,
            startDate,
            inline: false,
            toggleSelected: false,
            locale: localeDe,
            dateFormat(date) {
                if(country === 'AT'){
                    const dates = getWeekDates(date, true);
                    return 'KW ' + getWeekNumber(dates[0]) + ' (' + dates[0].toLocaleString('de', {
                        year: 'numeric',
                        day: '2-digit',
                        month: '2-digit',
                    }) + ' - ' + dates[4].toLocaleString('de', {
                        year: 'numeric',
                        day: '2-digit',
                        month: '2-digit',
                    }) + ')';
                }
                return date.toLocaleString('de', {
                    year: 'numeric',
                    day: '2-digit',
                    month: '2-digit',
                });
            },
            selectedDates: [startDate],
            onSelect({date, datepicker}) {
                if (country === 'AT') {
                    datepicker.$datepicker.querySelectorAll('.air-datepicker-body--cells.-days- > div').forEach(el => el.classList.remove('-selected-'));

                   const dates = getWeekDates(date);


                    dates.forEach((d, i) => {
                        datepicker.$datepicker.querySelector('.air-datepicker-body--cells.-days- >div[data-iso-date="' + d + '"]').classList.add('-selected-');

                    })
                }
                calendar.hide();
            },
            onRenderCell({date, cellType,datepicker}) {
                if (cellType === 'day' && [0, 6].includes(date.getDay())) {
                    return {
                        classes: '-disabled-',
                    }
                }

                if (country === 'AT') {
                    const dates = getWeekDates(datepicker.selectedDates[0]);
                    const curDate = new Date(date);



                    if (cellType === 'day') {
                        return {
                            classes: 'week-day day-' + date.getDay() +  (dates.includes(curDate.getFullYear() + '-' +
                                String(curDate.getMonth() + 1).padStart(2, '0') + '-' +
                                String(curDate.getDate()).padStart(2, '0')) ? ' -selected-' : ''),
                        }
                    }

                }
            },
            onFocus({date, datepicker}) {
                if (country === 'AT') {
                    datepicker.$datepicker.querySelectorAll('.air-datepicker-body--cells.-days- > div').forEach(el => el.classList.remove('-focus-'));
                    const dates = getWeekDates(date);


                    dates.forEach((d, i) => {
                        datepicker.$datepicker.querySelector('.air-datepicker-body--cells.-days- >div[data-iso-date="' + d + '"]').classList.add('-focus-');

                    })

                }
            }
        });
    });
}

function initNextDeliveryDatepicker() {
    document.querySelectorAll('.next-delivery-date-picker').forEach(el => {
        const section = el.closest('section[x-data]');
        if (!section) return;


        const alpineData = Alpine.$data(section);

        console.log(alpineData);

        let minDate = new Date(el.dataset.minDate);
        let startDate = new Date(el.dataset.startDate);
        let country = el.dataset.country;


        const calendar = new AirDatepicker('#' + el.id, {
            minDate,
            startDate,
            inline: true,
            locale: localeDe,
            format: 'DD.MM.YYYY',
            selectedDates: [startDate],
            onSelect(cell) {

                if (country === 'AT') {
                    cell.datepicker.$datepicker.querySelectorAll('.air-datepicker-body--cells.-days- > div').forEach(el => el.classList.remove('-selected-'));

                    const dates = getWeekDates(cell.date);


                    dates.forEach((d, i) => {
                        cell.datepicker.$datepicker.querySelector('.air-datepicker-body--cells.-days- >div[data-iso-date="' + d + '"]').classList.add('-selected-');

                    });
                    alpineData.nextDeliveryDateNew = dates[1];

                }else{
                    alpineData.nextDeliveryDateNew = adFormatDate(cell.date);
                }
            },

            onRenderCell({date, cellType,datepicker}) {
                if (cellType === 'day' && [0, 6].includes(date.getDay())) {
                    return {
                        classes: '-disabled-',
                    }
                }

                if (country === 'AT') {
                    const dates = getWeekDates(datepicker.selectedDates[0]);
                    const curDate = new Date(date);



                    if (cellType === 'day') {
                        return {
                            classes: 'week-day day-' + date.getDay() +  (dates.includes(curDate.getFullYear() + '-' +
                                String(curDate.getMonth() + 1).padStart(2, '0') + '-' +
                                String(curDate.getDate()).padStart(2, '0')) ? ' -selected-' : ''),
                        }
                    }

                }
            },
            onFocus({date, datepicker}) {
                if (country === 'AT') {
                    datepicker.$datepicker.querySelectorAll('.air-datepicker-body--cells.-days- > div').forEach(el => el.classList.remove('-focus-'));
                    const dates = getWeekDates(date);


                    dates.forEach((d, i) => {
                        datepicker.$datepicker.querySelector('.air-datepicker-body--cells.-days- >div[data-iso-date="' + d + '"]').classList.add('-focus-');

                    })

                }
            },

        });


        Alpine.watch(() => alpineData.editDeliveryDateModal, (isOpen) => {
            if (isOpen) {
                let startDate = new Date(el.dataset.startDate);

                calendar.update({selectedDates: [startDate]});
            } else {
                // Modal geschlossen → reset
                alpineData.pauseDates = [];
            }
        });
    });
}

function init() {
    initSubscriptionDatepicker();
    initCart();
    initFirstDeliveryDatepicker();
    initNextDeliveryDatepicker();
    initDeliveryTimeInfo();
}

if (window.Alpine) {
    init();
} else {
    document.addEventListener('alpine:init', init, {once: true});
}

function runInitAjaxCartNumber() {
    try { initAjaxCartNumber(); } catch (e) {}
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runInitAjaxCartNumber, { once: true });
} else {
    runInitAjaxCartNumber();
}

function hideFuetterungPanel() {
    document.querySelectorAll('.aktivdog-hide-parent-panel').forEach(function (marker) {
        var panel = marker.closest('.fusion-panel');
        if (panel) panel.style.display = 'none';
    });
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", hideFuetterungPanel, { once: true });
} else {
    hideFuetterungPanel();
}

function wrapBtnForTextFlip(btn) {
    if (btn.dataset.textFlip === '1') return;
    if (btn.querySelector('.btn-flip-inner')) return;
    if (btn.childElementCount > 0) return;
    var label = btn.textContent.trim();
    if (!label) return;
    btn.dataset.textFlip = '1';
    btn.innerHTML = '<span class="btn-flip-inner">'
        + '<span class="btn-flip-text">' + label.replace(/[&<>]/g, function (c) { return {'&':'&amp;','<':'&lt;','>':'&gt;'}[c]; }) + '</span>'
        + '<span class="btn-flip-text btn-flip-text--hover" aria-hidden="true">' + label.replace(/[&<>]/g, function (c) { return {'&':'&amp;','<':'&lt;','>':'&gt;'}[c]; }) + '</span>'
        + '</span>';
}

function initBtnTextFlip(root) {
    (root || document).querySelectorAll('.btn').forEach(wrapBtnForTextFlip);
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initBtnTextFlip(); }, { once: true });
} else {
    initBtnTextFlip();
}

if (typeof MutationObserver !== 'undefined') {
    var btnFlipObserver = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
            var added = mutations[i].addedNodes;
            for (var j = 0; j < added.length; j++) {
                var node = added[j];
                if (node.nodeType !== 1) continue;
                if (node.matches && node.matches('.btn')) wrapBtnForTextFlip(node);
                if (node.querySelectorAll) initBtnTextFlip(node);
            }
        }
    });
    btnFlipObserver.observe(document.body, { childList: true, subtree: true });
}

